// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"e5f3d783","378":"7830fc45","787":"cc6cb21b"}[chunkId] + ".chunk.js";
};